import * as MomentRange from 'moment-range/dist/moment-range'
window['moment-range'] = MomentRange;
